import { intersection } from "lodash";
import { RolePermissions } from "../../../../../../enums";

export const detectHasAnyPermissions = (permissions: RolePermissions[]) =>
  intersection(permissions, [RolePermissions.FlowsManage, RolePermissions.FlowsCreate]).length > 0;
